import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import {showModalPageClass, showLoader, hideLoader, setTestData, setDataForm, setTextInputLongitud, cleanDataForm} from '../../../functions';
import $ from 'jquery';

export default class FichaProductoPartidas extends Component {

    constructor(props)
	{
        super(props);
    }

    state = {
        fichaProductoPartidas : [],
        actionForm: "",
        guardando: false
    }

    render() {
        return (
            <div>
                 <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Ficha Producto</span>
                        <span> / Partidas</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Partidas
                </div>
                <div className="divSector_Panel">
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                            <tbody>
                                <tr>
                                    <th>N°</th>
                                    <th>Código Partida</th>
                                    <th>Partida</th>
                                    <th width={"100"}>Acciones</th>
                                </tr>
                                {
                                    this.state.fichaProductoPartidas.length > 0 ? 
                                    
                                    this.state.fichaProductoPartidas.map((item, index) => (
                                        <tr key={`ficha-producto-partida-${item.id}`}>
                                            <td>{index + 1}</td>
                                            <td>{item.partidaCodigo}</td>
                                            <td>{item.partidaDescripcion}</td>
                                            <td>
                                                <div className="divBtnAcciones">
                                                    <a href="#" className="btnPageModuloEliminar aEliminarMenu2"/>
                                                    <div className="c_divAlertaCapa">
                                                        <div className="divAlertaCapa">
                                                            <div className="divAlerta">
                                                                <h2>&iquest;Seguro de eliminar?</h2>
                                                                <div className="divAlertaBtn">
                                                                    <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(event, item)}>ACEPTAR</a>
                                                                    <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                    :

                                    (
                                        <tr>
                                            <td colSpan="4" className="tdSinResultados">
                                                No se encontró resultados.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" id="btnCreateGlosario" onClick={(e) => this.showCrearFichaProductoPartida(e)}>AGREGAR </a>
                            <a href="" className="btnPrevAddPalabraGlosario" onClick={(event) => this.regresarFichaProducto(event)}>VOLVER</a>
                        </div>
                        <div id="containerForm" style={{display:"none"}}>
                            <div className="divGlosario">
                                <h2>Formulario Ficha Producto Partida</h2>
                                <div className="containerFormCreate">
                                    <div className="divWrapperGlosario2">
                                        <div className="divAddPalabraGlosario">
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Código de Partida" id='PartidaCodigo' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudPartidaCodigo"></span>
                                            </div>
                                        </div>
                                        <div className="divContenedorBtn_Glosario">
                                            <a href="" className="btnAddPalabraGlosario btnActivo" onClick={(event) => this.guardarForm(event)}>{this.state.actionForm == "G" ? "GUARDAR" :  "ACTUALIZAR"}</a>
                                            <a href="#" className="btnPrevAddPalabraGlosario" onClick={(event) => this.cancelarForm(event)}>CANCELAR</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getFichaProductoPartidas(){
        showLoader();

        const url = `${API_URL}FichaProductoPartidaUX/Listar?productoCodigo=${this.props.match.params.id}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                
                this.setState({ 
                    fichaProductoPartidas: data.result.data
                });
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar');
            });
    }

    regresarFichaProducto(e) {
        e.preventDefault();

        const {history: {push}} = this.props;
        push('/ficha-producto');
    }  

    eliminarRegistro = (event, entity) => {
        event.preventDefault();

        const url = `${API_URL}FichaProductoPartidaUX/Eliminar` ;
        const me = this;

        axios.post(url, JSON.stringify(JSON.stringify(entity)), { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {
            
            me.setState({ guardando:false });
            
            if(data.data.result.status){
                toast.success('Partida Eliminada.');
                this.getFichaProductoPartidas();
                $("#containerForm").fadeOut();
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            me.setState({ guardando:false });
        });
    }

    showCrearFichaProductoPartida = (event) => {
        event.preventDefault();

        cleanDataForm();

        this.setState({
            actionForm: "G"
        });

        $("#containerForm").fadeIn();
    }

    guardarForm = (e) => {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = this.state.actionForm == "G" ? `${API_URL}FichaProductoPartidaUX/Insertar` : `${API_URL}FichaProductoPartidaUX/Actualizar`;
            
            let fichaProductoPartida = {
                "ProductoCodigo": this.props.match.params.id
            };
            
            setDataForm(fichaProductoPartida);
    
            axios.post(url, JSON.stringify(JSON.stringify(fichaProductoPartida)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                
                me.setState({ guardando:false });
                
                if(data.data.result.status){
                    toast.success(this.state.actionForm == "G" ? 'Partida Agregada.' : 'Partida Actualizado.');
                    this.getFichaProductoPartidas();
                    $("#containerForm").fadeOut();
                }else{
                    toast.error(data.data.result.error);
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    cancelarForm = (e) => {
        e.preventDefault();

        $("#containerForm").fadeOut();
    }
	
    componentDidMount()
	{
        this.getFichaProductoPartidas();

        setTextInputLongitud(['PartidaCodigo']);
    }
}
